import axios from 'axios';

// Create an axios instance with default config
const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL, // Use REACT_APP_API_URL for consistency
  headers: {
    'Content-Type': 'application/json',
    'X-Requested-With': 'XMLHttpRequest'  // Prevents unnecessary CORS preflight
  }
});

// Debug: Log all outgoing requests
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('research_token');
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    console.log('[api.js] Outgoing request:', config.method, config.url, 'headers:', config.headers, 'data:', config.data);
    return config;
  },
  (error) => {
    console.error('[api.js] Request error:', error);
    return Promise.reject(error);
  }
);

// Add a request interceptor to include the JWT token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('research_token');
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Login function
export const login = async (credentials) => {
  try {
    // CAPTCHA COMMENTED OUT FOR PRODUCTION DEPLOYMENT
    // Extract captcha token to send in custom header
    // const { captchaToken, ...loginData } = credentials;

    // Create request with custom header for captcha token
    const response = await api.post('/auth/login', credentials, {
      headers: {
        // ...(captchaToken && { 'X-Captcha-Token': captchaToken }) // COMMENTED OUT FOR PRODUCTION
      }
    });

    return response.data;
  } catch (error) {
    throw error;
  }
};

// Dashboard preferences API functions
export const getDashboardPreferences = async () => {
  try {
    const response = await api.get('/dashboard/dashboard-preferences');
    return response.data;
  } catch (error) {
    console.error('Error fetching dashboard preferences:', error);
    // Return default values if API fails
    return {
      stats_cards_visible: true,
      welcome_section_visible: true,
      quick_actions_visible: true,
      role_specific_sections: {}
    };
  }
};

export const updateDashboardPreferences = async (preferences) => {
  try {
    const response = await api.put('/dashboard/dashboard-preferences', preferences);
    return response.data;
  } catch (error) {
    console.error('Error updating dashboard preferences:', error);
    throw error;
  }
};

export const resetDashboardPreferences = async () => {
  try {
    const response = await api.post('/dashboard/dashboard-preferences/reset');
    return response.data;
  } catch (error) {
    console.error('Error resetting dashboard preferences:', error);
    throw error;
  }
};

// Debug: Log all responses
api.interceptors.response.use(
  (response) => {
    console.log('[api.js] Response:', response.config.url, 'status:', response.status, 'data:', response.data);
    return response;
  },
  (error) => {
    if (error.response) {
      console.error('[api.js] Response error:', error.response.config?.url, 'status:', error.response.status, 'data:', error.response.data);
    } else {
      console.error('[api.js] Network or other error:', error);
    }
    return Promise.reject(error);
  }
);

// BMI calculation API functions
export const calculateBMI = async (height, heightUnit, weight, weightUnit) => {
  try {
    console.log('API: Calculating BMI with:', { height, heightUnit, weight, weightUnit });
    const response = await api.post('/assessments/bmi', {
      height,
      height_unit: heightUnit,
      weight,
      weight_unit: weightUnit
    });
    console.log('API: BMI calculation response:', response.data);
    return response.data;
  } catch (error) {
    console.error('API: Error calculating BMI:', error);
    throw error;
  }
};

export const getAssessmentBMI = async (assessmentId) => {
  try {
    const response = await api.get(`/assessments/${assessmentId}/bmi`);
    return response.data;
  } catch (error) {
    console.error('Error getting assessment BMI:', error);
    throw error;
  }
};

// Only use the axios api instance for backend calls
export default api;